import httpClient from "@/plugins/axios";

export const getEvents = async (page, pageSize = 10) => {
    const response = await httpClient.get(`/v1/events/?page=${page}&page_size=${pageSize}`);
    return response;
}

export const getEvent = async (id) => {
    const response = await httpClient.get(`/v1/events/${id}/`);
    return response;
}

export const getEventEnrollment = async (id) => {
    const response = await httpClient.get(`/v1/events/${id}/enrollment/`);
    return response;
}

export const enrollEvent = async (id, comment) => {
    const response = await httpClient.post(`/v1/events/${id}/enrollment/`, {
        comment
    });
    return response;
}

export const cancelEventEnrollment = async (id) => {
    const response = await httpClient.delete(`/v1/events/${id}/enrollment/`);
    return response;
}

